import { useContext, useEffect, useState } from 'react';
import Moment from 'react-moment';
import { Button, Group, Space, Text, useMantineTheme } from '@mantine/core';
import { IconCopy, IconExternalLink, IconLock } from '@tabler/icons';
import { ModalDialog, useConfirmModalState, useModalState } from '../../Molecules/Dialogs';
import TooltipButton from '../../Atoms/buttons/TooltipButton';
import { TransButtonDefault } from '../../Atoms/Buttons';
import { EditableShareProperty } from '../../Atoms/EditableProperties/EditableShareProperty';
import { StringFormatter } from '../../Atoms/Formatter/StringFormatter';
import { SimpleEditableText } from '../../Atoms/inputs/SimpleEditableText';
import EditableDateInput from '../../Atoms/inputs/EditableDateInput';
import { DateFormatter } from '../../Atoms/Formatter/DateFormatter';
import { WindowContext } from '../../Service/Context/WindowContext';
import { EventPortalContext } from '../../Service/Context/EventPortalContext';
import { RoutingS } from '../../Service/RoutingS';
import SharedResourceList from './SharedResourceList';
import { useClipboard } from '@mantine/hooks';

// eslint-disable-next-line import/no-anonymous-default-export, func-names, react/function-component-definition
const ShareItem = ({ share, eventId }) => {
  const { reload, resetLastLogin } = useContext(EventPortalContext);
  const { show, toggle } = useModalState(false);
  const { showConfirm, toggleConfirm } = useConfirmModalState(false);
  const [link, setLink] = useState(undefined);
  const { windowWidth } = useContext(WindowContext);
  const { colorScheme, colors } = useMantineTheme();
  const clipboard = useClipboard({ timeout: 500 });

  useEffect(() => {
    setLink(`${process.env.REACT_APP_PORTAL_SERVICE_URL}/login?shareId=${share.id}&key=${share.password}`);
  }, [share]);

  const handleChange = (patch) => {
    reload();
  };

  const styles = {
    containerBorder: {
      border: '1px solid rgba(0, 0, 0, 0.125)',
      borderRadius: '4px',
      padding: 5,
      marginBottom: 5,
    },
    container: {
      display: 'flex',
      justifyContent: 'space-between',
      marginBottom: 5,
      flexDirection: 'column',
    },
    infos: {
      flex: 1,
      borderRadius: 4,
      padding: 5,
      display: 'flex',
      justifyContent: 'space-between',
    },
    dates: {
      display: 'flex',
      color: '#666666',
      fontSize: 13,
    },
    links: {
      display: 'flex',
    },

    description: {
      color: '#666666',
      fontSize: 12,
      alignSelf: 'center',
      display: 'flex',
    },
    codeField: {
      fontSize: 10,
    },
  };

  return (
    <>
      <div style={{ maxWidth: 400, marginTop: 10 }}>
        {windowWidth > 800 && <Text style={{ marginRight: 10, alignSelf: 'center' }}>Beschreibung des Zugangs:</Text>}
        <EditableShareProperty
          patchField="name"
          inlinePlaceholder="Name des Zugangs"
          handleChange={handleChange}
          entity={share}
          labelFormatter={StringFormatter}
          editFormatter={SimpleEditableText}
        />
      </div>
      <Group mt="xs" mb="xl">
        <Text>
          Geteilt bis:{' '}
          {share.sharedUntil ? (
            <>
              {' '}
              <Moment fromNow>{share.sharedUntil}</Moment>{' '}
            </>
          ) : (
            'Unbegrenzt'
          )}
          <TooltipButton
            style={{ marginLeft: 5 }}
            icon="EDIT"
            id={`shared-until-${share.id}`}
            text="Geteilt bis ändern"
            onClick={toggleConfirm}
          />
        </Text>
        <Text>
          Letzter Login ins Portal:{'  '}
          {share.lastLogin && <Moment fromNow>{share.lastLogin}</Moment>}
          {!share.lastLogin && <Text span>nie</Text>}
          {share.lastLogin && (
            <TooltipButton
              style={{ marginLeft: 5 }}
              icon="HISTORY"
              id="reset-portal-last-login"
              text="Zeitpunkt zurücksetzen"
              onClick={() => resetLastLogin(share.id)}
            />
          )}
        </Text>
      </Group>
      <Group spacing={0}>
        <Button size="xs" variant="subtle" leftIcon={<IconCopy size={16} />} onClick={() => clipboard.copy(link)}>
          {clipboard.copied ? 'Kopiert' : 'Link kopieren'}
        </Button>
        <Button
          size="xs"
          variant="subtle"
          leftIcon={<IconExternalLink size={16} />}
          onClick={() => RoutingS.openInNewTab(link)}
        >
          Portal öffnen
        </Button>
        <Button size="xs" variant="subtle" leftIcon={<IconLock size={16} />} onClick={toggle}>
          Kennwort ändern
        </Button>
      </Group>
      <ModalDialog
        header="Zugangspasswort ändern"
        body={
          <div>
            <EditableShareProperty
              patchField="password"
              placeholder="Kennwort"
              handleChange={handleChange}
              entity={share}
              labelFormatter={StringFormatter}
              editFormatter={SimpleEditableText}
            />
          </div>
        }
        footer={<TransButtonDefault onClickHandler={toggle} text="actions.ok" />}
        show={show}
        toggle={toggle}
      />

      <ModalDialog
        className="modal-xl"
        header="Freigabedatum ändern"
        body={
          <div>
            <EditableShareProperty
              patchField="sharedUntil"
              placeholder="Geteilt bis"
              handleChange={handleChange}
              entity={share}
              labelFormatter={DateFormatter}
              editFormatter={EditableDateInput}
            />
          </div>
        }
        footer={<TransButtonDefault onClickHandler={toggleConfirm} text="actions.ok" />}
        show={showConfirm}
        toggle={toggleConfirm}
      />
      <Space h="xl" />
      <SharedResourceList shareId={share.id} eventId={eventId} />
      <Space h="xl" />
    </>
  );
};

export default ShareItem;
